import { render, staticRenderFns } from "./updateYuce.vue?vue&type=template&id=57644cde"
import script from "./updateYuce.vue?vue&type=script&lang=js"
export * from "./updateYuce.vue?vue&type=script&lang=js"
import style0 from "./updateYuce.vue?vue&type=style&index=0&id=57644cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports